// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1S04v","clinicsSelect":"TableHeading_clinicsSelect__RvVkt"};